.container {
	position: absolute;
	width: 100%;
	justify-content: center;
	bottom: var(--mantine-spacing-md);
	z-index: 5;
	@include screen-sm {
		left: 16px;
		transform: none;
	}
}
.instructionsButton {
	position: absolute;
	left: var(--mantine-spacing-md);
}
